const commitPaper = {
  path: 'commitPaper',
  component: resolve => require(['../../../../components/pages/signUp/commitPaper'], resolve)
}
export default commitPaper



// WEBPACK FOOTER //
// ./src/router/pages/signUp/commitPaper/index.js